import React, { useState, useEffect } from 'react';
import { WifiOutlined } from '@ant-design/icons';

const OnlineStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        let timeout;

        const updateStatus = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setIsOnline(navigator.onLine);
            }, 500);
        };

        window.addEventListener('online', updateStatus);
        window.addEventListener('offline', updateStatus);

        return () => {
            window.removeEventListener('online', updateStatus);
            window.removeEventListener('offline', updateStatus);
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div style={{ paddingLeft: '10px' }}>
            {isOnline ? (
                <WifiOutlined style={{ color: 'green' }} />
            ) : (
                <span className='offline-icon'
                >
                    <WifiOutlined />
                </span>
            )}
        </div>
    );
};

export default OnlineStatus;
